module.exports = __webpack_public_path__ + "img/label.77039492.svg";